import HomePage from '../pages/home.f7.html';
import AddHomePage from '../pages/addhome.f7.html';
import AboutPage from '../pages/about.f7.html';
import GuidelinesPage from '../pages/guidelines.f7.html';
import NIHSSPage from '../pages/NIHSS.f7.html';
import tPAPage from '../pages/tPA.f7.html';
import ThrombectomyPage from '../pages/thrombectomy.f7.html';
import ABC2Page from '../pages/ABC2.f7.html';
import ABCD2Page from '../pages/ABCD2.f7.html';
import CHA2DS2VASCPage from '../pages/CHA2DS2VASC.f7.html';
import ASPECTSPage from '../pages/ASPECTS.f7.html';
import SuzukiPage from '../pages/Suzuki.f7.html';
import MRIbloodPage from '../pages/MRIblood.f7.html';
import HASBLEDPage from '../pages/HASBLED.f7.html';
import ICHPage from '../pages/ICH.f7.html';
import SAHPage from '../pages/SAH.f7.html';
import AVMPage from '../pages/AVM.f7.html';
import ISUIAPage from '../pages/ISUIA.f7.html';
import PhenytoinPage from '../pages/phenytoin.f7.html';
import GCSPage from '../pages/GCS.f7.html';
import FOURPage from '../pages/FOUR.f7.html';
import NASCETPage from '../pages/NASCET.f7.html';
import mRSPage from '../pages/mRS.f7.html';
import BIPage from '../pages/BI.f7.html';

import DynamicRoutePage from '../pages/dynamic-route.f7.html';
import RequestAndLoad from '../pages/request-and-load.f7.html';
import NotFoundPage from '../pages/404.f7.html';

var routes = [
  {
    path: '/',
    component: HomePage,
    on: {
      pageInit: function () {
        window.addEventListener('beforeinstallprompt', function(event) {
          window.installPromptEvent = event;
        });
      }
    },
  },
  {
    path: '/addhome/',
    component: AddHomePage,
  },
  {
    path: '/guidelines/',
    component: GuidelinesPage,
  },
  {
    path: '/NIHSS/',
    component: NIHSSPage,
  },
  {
    path: '/tPA/',
    component: tPAPage,
  },
  {
    path: '/thrombectomy/',
    component: ThrombectomyPage,
  },
  {
    path: '/ABC2/',
    component: ABC2Page,
  },
  {
    path: '/ABCD2/',
    component: ABCD2Page,
  },
  {
    path: '/CHA2DS2VASC/',
    component: CHA2DS2VASCPage,
  },
  {
    path: '/ASPECTS/',
    component: ASPECTSPage,
  },
  {
    path: '/Suzuki/',
    component: SuzukiPage,
  },
  {
    path: '/ICH/',
    component: ICHPage,
  },
  {
    path: '/HASBLED/',
    component: HASBLEDPage,
  },
  {
    path: '/MRIblood/',
    component: MRIbloodPage,
  },
  {
    path: '/SAH/',
    component: SAHPage,
  },
  {
    path: '/AVM/',
    component: AVMPage,
  },
  {
    path: '/ISUIA/',
    component: ISUIAPage,
  },
  {
    path: '/phenytoin/',
    component: PhenytoinPage,
  },
  {
    path: '/GCS/',
    component: GCSPage,
  },
  {
    path: '/FOUR/',
    component: FOURPage,
  },
  {
    path: '/NASCET/',
    component: NASCETPage,
  },
  {
    path: '/mRS/',
    component: mRSPage,
  },
  {
    path: '/BI/',
    component: BIPage,
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Dion',
          lastName: 'Fung',
          about: 'Hello, i am creator of StrokeMD! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;